import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const Icon = styled(FontAwesomeIcon)`
    color: ${(props) => props.theme.colors["gray-light"]};
    font-size: ${(props) => {
        if (Number.isFinite(props.fontSize)) return props.theme.size(props.fontSize);
        return props.theme.fontSizeSmall;
    }};
    
    ${(props) => props.$shouldHover && `
        &:hover {
            cursor: pointer;
            color: ${props.theme.colors["gray-dark"]}
        }
    `}
`;
